import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票内容")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }

import { withDefaults, ref, defineModel } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseDatePicker,
  BaseSelect,
  BaseInputNumber,
  BaseInput
} from 'xrk-components';
import { IndustryDetailData } from '@V/invoice/src/data-source/types';
import { industryGetCsoInvoiceCate } from '@V/invoice/src/data-source/apis';
import { INVOICE_TYPE } from '@V/invoice/src/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-offline-dialog-content',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {



const formData = _useModel<IndustryDetailData>(__props, "modelValue");
const formRef = ref(null);

const formRules = {
  invoiceAmount: [{ required: true, message: '请输入', trigger: 'change' }],
  invoiceType: [{ required: true, message: '请选择', trigger: 'change' }],
  itemId: [{ required: true, message: '请选择', trigger: 'change' }]
  // taskAt: [{ required: true, message: '请选择', trigger: 'change' }]
};

/**
 * @description: 获取当前企业关联的发票类目列表
 *               注意：工业角色只能查看本企业类目，其他企业类目不会显示
 *               在禁用状态下，将直接显示类目名称而不进行搜索
 */
const itemIdRemote = () => {
  return industryGetCsoInvoiceCate();
};

const onInvoiceTypeChange = (v, option) => {
  formData.value.invoiceTypeName = option.label;
};
const onitemIdChange = (v, [option]) => {
  formData.value.itemName = option.itemName;
};

__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    model: formData.value,
    rules: formRules,
    disabled: _ctx.disabled
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "开票金额",
          prop: "invoiceAmount"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInputNumber), {
              style: {"width":"100%"},
              placeholder: "请输入",
              controls: false,
              precision: 2,
              min: 0,
              max: 999999999,
              modelValue: formData.value.invoiceAmount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.invoiceAmount) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "发票类型",
          prop: "invoiceType"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              options: _unref(INVOICE_TYPE),
              modelValue: formData.value.invoiceType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.invoiceType) = $event)),
              onChange: onInvoiceTypeChange
            }, null, 8, ["options", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开票类目",
          prop: "itemId"
        }, {
          default: _withCtx(() => [
            (!_ctx.disabled)
              ? (_openBlock(), _createBlock(_unref(BaseSelect), {
                  key: 0,
                  class: "form-dialog__w280",
                  type: "text",
                  placeholder: "请选择",
                  "label-key": "itemName",
                  "value-key": "id",
                  init: true,
                  remoteMethod: itemIdRemote,
                  modelValue: formData.value.itemId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.itemId) = $event)),
                  onChange: onitemIdChange
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_unref(BaseInput), {
                  key: 1,
                  class: "form-dialog__w280",
                  type: "text",
                  modelValue: formData.value.itemName
                }, null, 8, ["modelValue"]))
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "结算月度",
          prop: "taskAt"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseDatePicker), {
              style: {"width":"100%"},
              placeholder: "请选择",
              type: "month",
              "validate-event": "",
              modelValue: formData.value.taskAt,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.taskAt) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model", "disabled"]))
}
}

})